import * as React from "react";
import { ICurrentLocationContext } from "../Types";

export const CutlioLocationContext = React.createContext<ICurrentLocationContext>({} as ICurrentLocationContext);
CutlioLocationContext.displayName = 'Cutlio current location context';

export function useCurrentLocation() {
  return React.useContext(CutlioLocationContext);
}